module.exports = __webpack_public_path__ + "static/media/covid_adolescent_p4_1.a46eb687.png";